import { useNavigate } from 'react-router-dom';

/**
 * Página mostrada cuando un usuario intenta acceder a una ruta o acción para
 * la que no tiene permiso en la empresa activa.
 */
const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--cm-paper)] px-4">
      <div className="max-w-md w-full rounded-lg border border-hairline bg-white shadow-card p-8 text-center">
        <div className="mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-pixel bg-danger/10 border border-danger/20">
          <svg className="w-8 h-8 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 9v2m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4a2 2 0 00-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z" />
          </svg>
        </div>
        <h1 className="font-display text-2xl font-semibold text-ink mb-2">Acceso denegado</h1>
        <p className="text-sage mb-6">
          No tenés permisos para acceder a esta sección en la empresa activa.
          Si creés que es un error, contactá al administrador de tu empresa.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="w-full bg-forest text-paper py-2.5 rounded-md font-medium hover:bg-forest-mid transition-colors"
        >
          Volver al panel
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
